var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userAccess == 2)?_c('home-main-auth'):(_vm.userAccess == 1)?_c('home-main-guest'):(_vm.userAccess == 0)?_c('home-main-public'):_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }